import { useQuery } from '@tanstack/react-query';
import { bffApiClient } from '@api/bff/client';

export type WorkOrderDetailSummary = {
  jobNumber: string | null;
  sequenceNumber: number | null;
  companyName: string | null;
  equipmentId: string | null;
  description: string | null;
  location: string | null;
};

export const useWorkOrderDetailByGlobalId = (
  globalId: string | null | undefined
) => {
  return useQuery<WorkOrderDetailSummary>({
    queryKey: ['workOrderDetail', 'byGlobalId', globalId],
    queryFn: async () => {
      const response = await bffApiClient.get<WorkOrderDetailSummary>(
        `/api/work-orders/detail/by-global-id/${globalId}`
      );
      return response.data;
    },
    enabled: !!globalId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000
  });
};
